exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".list-handler[data-v-7a32e5a6] {\n  cursor: move;\n  left: -0.8rem;\n  position: absolute;\n  transition: opacity var(--fast) var(--smooth);\n}", ""]);

// exports
